import { faker } from "@faker-js/faker";
import { Factory } from "fishery";
import { MoneyType, WalletMonies } from "../components/Money/types";
import { DEFAULT_PRECISION } from "../components/Wallet/utils";

export const moneyFactory = Factory.define<MoneyType>(() => {
  return {
    amount: faker.number.int({ max: 10000000000, min: 100 }),
    currency: "USD",
    precision: DEFAULT_PRECISION,
  };
});

export const walletFactory = Factory.define<WalletMonies>(() => {
  return {
    monies: [moneyFactory.build()],
  };
});
